import { render } from "./baseFieldContainer.vue?vue&type=template&id=b8236bde"
import script from "./baseFieldContainer.vue?vue&type=script&lang=js"
export * from "./baseFieldContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__